import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import { getLeadSalesCards } from "../../../../../services/crm/leadService";
import Illustration from "../../../../../partials/content/Illustration";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import SalesCardDetail from "../../slc/salesCardDetail";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
function LeadSalesCards({ history, leadID }) {
  const { reload } = useGlobalData();
  const [salesCards, setSalesCards] = useState([]);
  const [openSalesCardDetail, setOpenSalesCardDetail] = useState(false);
  const [salesCardID, setSalesCardID] = useState(0);
  useEffect(() => {
    getLeadSalesCardsData(leadID);
  }, [leadID, reload]);

  const leadSalesCardDetailColumn = [
    {
      header: "Assigned To",
      field: "assignedUserName",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      {salesCards.length ? (
        <React.Fragment>
          <CustomDataTable
            data={salesCards}
            dataDetailColumns={leadSalesCardDetailColumn}
            onRefreshData={() => {
              getLeadSalesCardsData(leadID);
            }}
            columns={[
              {
                header: "Sales Card Name",
                field: "title",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.title} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Estimated Value",
                field: "estimatedValue",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.estimatedValue}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Quotation Value",
                field: "quotation.grandTotal",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.quotation.grandTotal}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Status",
                field: "slcStatus.statusName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.slcStatus.statusName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Sales Card Detail">
                      <button
                        type="button"
                        onClick={() => {
                          setSalesCardID(rowData.ID);
                          setOpenSalesCardDetail(true);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO CRM.png"
            guidance="You don't have any Sales Cards for this lead yet"
            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                history.push("/crm/slc");
              }}
            >
              <i className="fas fa-map-marker-alt"></i>
              Go To Sales Life Cycle
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openSalesCardDetail}
        title="Sales Card Detail"
        minHeight={true}
        onCloseDialog={handleCloseSalesCardDetail}
      >
        <SalesCardDetail
          salesCardID={salesCardID}
          onCloseDialog={handleCloseSalesCardDetail}
          onReloadSalesCards={() => {
            getLeadSalesCardsData(leadID);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseSalesCardDetail}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
  async function getLeadSalesCardsData(leadID) {
    const response = await getLeadSalesCards(leadID);
    const { data } = response.data;
    setSalesCards(data.salesCards);
  }

  function handleCloseSalesCardDetail() {
    setOpenSalesCardDetail(false);
  }
}

export default LeadSalesCards;
